import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { useDispatch } from "react-redux";
import {
  FONT_SIZE_CHANGED,
  VISION_IMPAIRED,
  AUTHORITIES,
} from "../../../constants/constants";
import { useMutationObserver } from "../../../hooks";
import axios from "axios";

const Navbar = ({
  navToken,
  messageId,
  loginUrl,
  logoutUrl,
  showEntitySearch,
  hidePersons,
  hideEntities,
  hideVisionImpaired,
  hideDyslexia,
  hideFontResize,
  hideLoginButton,
  changeEntityUrl,
  isAuthenticated,
  logout,
  test,
  legalIzvor,
  personOib,
  toLegalIps,
  toLegalIzvor,
  forLegalIps,
  BASE_URL,
  userOib,
}) => {
  const [scriptLoaded, setScriptLoaded] = useState("start");
  const dispatch = useDispatch();

  const initMount = useRef(true);
  const navRef = useRef();
  const scriptRef = useRef();

  let navbarTestUrl = "https://eusluge-nav-test.gov.hr/e_gradani.aspx";
  let navbarProdUrl = "https://eusluge-nav.gov.hr/e_gradani.aspx";

  const mountScript = (src) => {
    const script = document.createElement("script");
    script.src = src;
    script.id = "navbar";
    script.async = true;
    script.ref = scriptRef;
    script.onload = () => {
      onScriptLoad();
    };
    document.body.appendChild(script);
  };

  const loadScript = (url) => {
    const script = document.getElementById("navbar");
    if (script) {
      script.parentNode.removeChild(script);
    }
    mountScript(url);
  };

  const buildUrl = () => {
    let url = `${test ? navbarTestUrl : navbarProdUrl}?`;
    if (messageId) {
      url += `&messageId=${messageId}`;
    }
    if (!messageId) {
      url += `&messageId=false`;
    }
    if (navToken) {
      url += `&navToken=${navToken}`;
    }
    if (loginUrl) {
      url += `&login_url=${loginUrl}`;
    }
    if (logoutUrl) {
      url += `&logout_url=${logoutUrl}`;
    }
    if (showEntitySearch) {
      url += "&show_entity_search=true";
    }
    if (hidePersons) {
      url += "&show_persons=false";
    }
    if (hideEntities) {
      url += "&show_entities=false";
    }
    if (hideVisionImpaired) {
      url += "&show_vision_impaired=false";
    }
    if (hideDyslexia) {
      url += "&show_dyslexia=false";
    }
    if (hideFontResize) {
      url += "&show_font_resize=false";
    }
    if (hideLoginButton) {
      url += "&show_login_button=false";
    }

    if (personOib && personOib != "null") {
      url += `&ForPersonOib=${personOib}`;
    }
    if (forLegalIps && forLegalIps != "null") {
      url += `&ForLegalIps=${forLegalIps}`;
    }
    if (legalIzvor && legalIzvor != "null") {
      url += `&ForLegalIzvor_reg=${legalIzvor}`;
    }
    if (toLegalIps && toLegalIps != "null") {
      url += `&ToLegalIps=${toLegalIps}`;
    }
    if (toLegalIzvor && toLegalIzvor != "null") {
      url += `&ToLegalIzvor_reg=${toLegalIzvor}`;
    }

    if (changeEntityUrl) {
      url +=
        "&change_entity_url=" +
        encodeURIComponent(
          BASE_URL +
            "/e-ovlastenja/promjena-subjekta?ForPersonOib={ForPersonOib}&ForLegalIps={ForLegalIps}&ForLegalIzvor_reg={ForLegalIzvor_reg}&ToLegalIps={ToLegalIps}&ToLegalIzvor_reg={ToLegalIzvor_reg}&userOib=" +
            userOib
        );
    }

    loadScript(url.replace("&", ""));
  };
  function authorities(payload) {
    return {
      type: AUTHORITIES,
      payload,
    };
  }
  const getAuthorities = () => {
    axios
      .get(`${BASE_URL}/user-data/authorities`, {withCredentials:true})
      .then((res) => {
        dispatch(authorities(res.data));
      })
      .finally(() => buildUrl());
  };

  useEffect(() => {
    if (initMount.current) {
      initMount.current = false;
      return;
    }

    getAuthorities();
  }, [
    messageId,
    navToken,
    loginUrl,
    logoutUrl,
    showEntitySearch,
    hidePersons,
    hideEntities,
    hideVisionImpaired,
    hideDyslexia,
    hideFontResize,
    hideLoginButton,
    test,
    personOib,
    forLegalIps,
    legalIzvor,
    toLegalIps,
    toLegalIzvor,
  ]);

  const onScriptLoad = () => {
    setScriptLoaded("done");
  };

  if (scriptLoaded === "start") {
    setScriptLoaded("loading");
    setTimeout(() => {
      buildUrl();
    }, 1);
  }

  const handleMutations = useCallback((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.id === "filter_holder") {
        const allowedValues = [
          "80",
          "85",
          "90",
          "95",
          "100",
          "105",
          "110",
          "115",
          "120",
        ];

        if (
          allowedValues.includes(
            mutation.target.style.cssText.replace(/\D/g, "")
          )
        ) {
          dispatch({
            type: FONT_SIZE_CHANGED,
            payload: mutation.target.style.cssText.replace(/\D/g, ""),
          });
        }
      }
      if (mutation.target.id === "impaired") {
        if (mutation.target.style.display.includes("flex")) {
          dispatch({
            type: VISION_IMPAIRED,
            payload: true,
          });
          return;
        }
        dispatch({
          type: VISION_IMPAIRED,
          payload: false,
        });
      }
      if (mutation.target.className === "zgl-button log_out") {
        if (mutation.target.style.display === "none" && isAuthenticated) {
          logout();
        }
      }
    });
  }, []);

  useMutationObserver({
    target: navRef,
    options: {
      childList: true,
      subtree: true,
      attributes: true,
      attributeOldValue: true,
    },
    callback: handleMutations,
  });

  return (
    <Fragment>
      <div ref={navRef}>
        <div className="egradani_traka-holder"></div>
      </div>
    </Fragment>
  );
};

export default Navbar;
